"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyUtils = void 0;
var CurrencyUtils;
(function (CurrencyUtils) {
    let CentsDisplay;
    (function (CentsDisplay) {
        CentsDisplay["ALWAYS"] = "always";
        CentsDisplay["NEVER"] = "never";
        CentsDisplay["IF_EXISTS"] = "if_exists";
    })(CentsDisplay = CurrencyUtils.CentsDisplay || (CurrencyUtils.CentsDisplay = {}));
    const formatCurrencyDefaultOptionsV2 = {
        centsDisplay: CentsDisplay.IF_EXISTS,
        currencySymbolFormat: "$",
    };
    /**
     * Formats a number to a more readable en-US price/currency
     *
     * @returns string e.g. $1,000
     */
    CurrencyUtils.convertNumberToCurrencyFormat = (num, { centsDisplay = CentsDisplay.IF_EXISTS, currencySymbolFormat = "$", } = formatCurrencyDefaultOptionsV2) => {
        if (typeof num !== "number") {
            return "";
        }
        let amount;
        if (centsDisplay === CentsDisplay.IF_EXISTS) {
            amount = Number.isInteger(num) ? num.toString() : num.toFixed(2);
        }
        else if (centsDisplay === CentsDisplay.NEVER) {
            amount = Math.trunc(num).toString();
        }
        else {
            amount = num.toFixed(2);
        }
        const result = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return `${currencySymbolFormat}` + result;
    };
})(CurrencyUtils || (exports.CurrencyUtils = CurrencyUtils = {}));
//# sourceMappingURL=CurrencyUtils.js.map